export const ActionDef = {
  FETCH_FORM_STATE: "FETCH_FORM_STATE",
  GET_FORM_STATE: "GET_FORM_STATE",
  UPDATE_FORM_STATE: "UPDATE_FORM_STATE",
  SET_FORM_STATE: "SET_FORM_STATE",
  ELEMENT_FROM_FORMSTATE: "ELEMENT_FROM_FORMSTATE",
  SET_GENERAL_DATA: "SET_GENERAL_DATA",
  SET_SELECTION_PAGE: "SET_SELECTION_PAGE",
  SET_APP_SCREENSHOT_SAVED_FLAG: "SET_APP_SCREENSHOT_SAVED_FLAG",
  Update_Contexts_States: "Update_Contexts_States",
   Update_State: "Update_State",
  SET_MAP : "SET_MAP",
  CLEAR_MAP : "CLEAR_MAP",
  ADD_NEW_ALERT : "ADD_NEW_ALERT",
  REMOVE_ALERT : "REMOVE_ALERT"
};